"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AbstractFilterItem {
    constructor(id, label, onValueChange) {
        this.id = id;
        this.label = label;
        this.onValueChange = onValueChange;
        this.NUMBER_RANGE_VALIDATION_MESSAGE = 'reporting.controls.page-filter.number-range-validation';
        this.DATE_RANGE_VALIDATION_MESSAGE = 'reporting.controls.page-filter.date-range-validation';
        this.validationMessage = '';
    }
    onFilterItemChange() {
        this.onValueChange && this.onValueChange.next();
    }
    getDefaultValue() {
        return null;
    }
    ;
}
exports.AbstractFilterItem = AbstractFilterItem;
//# sourceMappingURL=abstract-filter-item.js.map